import Client from "./clients/rest";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {
    getCity(key) {
        return Client.get(`/meta/address/cities?key=${key}`)
    },

    getStreets(cityCode) {
        return Client.get(`/meta/address/cities/${cityCode}/streets`)

    }
}